<div class="docs-shell">
  <div class="tab-group-wrapper" #tabGroupWrapper>
    <mat-tab-group
      class="tab-group"
      animationDuration="150ms"
      (selectedTabChange)="onTabChange($event)"
      [selectedIndex]="computeSelectedIndex()"
    >
      <!-- Documents list tab -->
      @if (hasListTab()) {
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">folder_open</mat-icon>
            {{ 'workOrderObjectList.documents' | translate }}
          </ng-template>
          <div class="doc-grid-container">
            @if (documents && documents.length > 0) {
              <div class="work-order-document-grid">
                @for (document of documents; track document.id) {
                  <app-work-order-document
                    [document]="document"
                    [hasNotification]="hasNotification(document.id)"
                    (addToTabs)="addToTabs($event)"
                  ></app-work-order-document>
                }
              </div>
            }
            @if (showTimeDocuments) {
              <div class="docs-lane-divider"></div>
              <div class="work-order-document-grid">
                @for (document of timeDocuments; track document.id) {
                  <app-work-order-document
                    [document]="document"
                    [hasNotification]="hasNotification(document.id)"
                    (addToTabs)="addToTabs($event)"
                  ></app-work-order-document>
                }
              </div>
            }
          </div>
        </mat-tab>
      }

      <!-- Open document tabs -->
      @for (document of displayedDocuments; track document.id) {
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-label-text" [title]="document.name">{{ document.name }}</span>
            <span
              class="tab-close-btn"
              role="button"
              [attr.aria-label]="'Close ' + document.name"
              (click)="removeFromTabs(document); $event.stopPropagation()"
            >
              <mat-icon>close</mat-icon>
            </span>
          </ng-template>
          @if (selectedDocument?.id === document.id) {
            <div class="pdf-tab-info"></div>
          }
        </mat-tab>
      }
    </mat-tab-group>
  </div>

  <!-- ── PDF Viewer ─────────────────────────────────────────────── -->
  @if (selectedDocument && !isListTabActive()) {
    @if (is3dDocument(selectedDocument)) {
      <div class="model-3d-viewer-wrapper">
        <app-model-3d-viewer
          [src]="selectedDocument.link"
          [externalFileName]="selectedDocument.filename"
          [knownFileType]="selectedDocument.fileType"
          [knownFileSize]="selectedDocument.fileSize"
        ></app-model-3d-viewer>
      </div>
    } @else if (isVideoDocument(selectedDocument)) {
      <div class="video-viewer-wrapper">
        <app-video-viewer
          [src]="selectedDocument.link"
          [externalFileName]="selectedDocument.filename"
          [knownFileType]="selectedDocument.fileType"
          [knownFileSize]="selectedDocument.fileSize"
        ></app-video-viewer>
      </div>
    } @else if (documentError) {
      <div class="pdf-viewer-wrapper doc-error">
        <mat-icon class="doc-error__icon">{{ isOfflineError ? 'cloud_off' : 'lock' }}</mat-icon>
        <p class="doc-error__text">{{ documentError | translate }}</p>
      </div>
    } @else {
      <div class="pdf-viewer-wrapper" #pdfViewerWrapper [class.is-fullscreen]="isFullscreen">
        <button class="fullscreen-btn" mat-icon-button (click)="toggleFullscreen()">
          <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <ngx-extended-pdf-viewer
          [id]="'pdfViewer_' + selectedDocument.id"
          [src]="docSrc"
          [useBrowserLocale]="true"
          [height]="isFullscreen ? '100dvh' : pdfViewerHeight"
          [showOpenFileButton]="false"
          [showSidebarButton]="true"
          [textLayer]="true"
          [zoom]="'page-width'"
          [delayFirstView]="0"
          [showDownloadButton]="false"
          [showSecondaryToolbarButton]="true"
          [showPresentationModeButton]="false"
          [showPrintButton]="'always-in-secondary-menu'"
          [showRotateCwButton]="'always-in-secondary-menu'"
          [showRotateCcwButton]="'always-in-secondary-menu'"
          [showHandToolButton]="false"
          [showScrollingButton]="false"
          [showSpreadButton]="false"
          [showPropertiesButton]="false"
          [showStampEditor]="false"
          [showDrawEditor]="false"
          [showTextEditor]="false"
          [showHighlightEditor]="false"
          [mobileFriendlyZoom]="'150%'"
          [page]="(getPageForDocument(selectedDocument.id) | async) ?? 1"
          (pageChange)="onPdfPageChange(selectedDocument.id, $event)"
          (pdfLoadingFailed)="onPdfLoadingFailed($event)"
        >
        </ngx-extended-pdf-viewer>
      </div>
    }
  }
  @if (isListTabActive()) {
    <div class="pdf-placeholder"></div>
  }
  @if (!hasListTab()) {
    <app-empty-list
      title="{{ 'workOrderDocuments.empty.title' | translate }}"
      info="{{ 'workOrderDocuments.empty.info' | translate }}"
    ></app-empty-list>
  }
</div>
